import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import i18n from '@/i18n.ts';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

// Queries whose backend response depends on Accept-Language. The quiz question is not listed: its own hook
// fetches it again with languageRefresh, so the switch does not count as a quiz revisit
export const LANGUAGE_DEPENDENT_QUERY_KEYS: readonly QueryKeyEnum[] = [
  QueryKeyEnum.ACTIVE_AREA_OF_INTERESTS,
  QueryKeyEnum.ADMIN_CANDIDATE_PROFILE,
  QueryKeyEnum.ADMIN_DASHBOARD,
  QueryKeyEnum.DICTIONARIES,
  QueryKeyEnum.GET_QUIZ_DEFINITION,
  QueryKeyEnum.GET_QUIZ_IDENTIFIERS,
  QueryKeyEnum.GET_SKILLS_ASSESSMENT,
  QueryKeyEnum.GET_USER_PERSONAL_DATA,
  QueryKeyEnum.GET_USER_SKILLS_ASSESSMENT,
];

export const useRefreshQueriesOnLanguageChange = (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Invalidating keeps the current data on screen until the new language arrives, so open forms are not reset
    const refreshLanguageDependentQueries = () => {
      void queryClient.invalidateQueries({
        predicate: query =>
          LANGUAGE_DEPENDENT_QUERY_KEYS.includes(query.queryKey[0] as QueryKeyEnum),
      });
    };

    i18n.on('languageChanged', refreshLanguageDependentQueries);
    return () => i18n.off('languageChanged', refreshLanguageDependentQueries);
  }, [queryClient]);
};
